import { AppStore } from "@alfresco/aca-shared/store";
import { Component, inject, Input,  OnInit } from "@angular/core";
import { FormArray, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { Store } from "@ngrx/store";
import { UdeuBoud } from "projects/deusto-extension/src/lib/model/classes/udeu-boud";
import { ACTION_TYPE_FIELD, APPROVAL_DATE_FIELD, EFFECTIVE_DATE_FIELD, PRIMARY_APPROVING_BODY_FIELD, PROVISION_NUMBER_FIELD, SECONDARY_APPROVING_BODY_FIELD, SECONDARY_APPROVING_BODY_SUB_FIELD, SUBTYPE_FIELD, TYPE_FIELD } from "projects/deusto-extension/src/lib/model/contants/udeu-boud";
import { CreateBoudDialogComponent } from "../../create-boud.dialog";
import { BoudActionTypes } from "projects/deusto-extension/src/lib/store/actions/boud-actions";
import { actionTypeEnum } from "projects/deusto-extension/src/lib/model/enums/boud-assoc-element-type";

@Component({
  selector: 'boud-element-form',
  templateUrl: './element-form.component.html',
  styleUrls: ['./element-form.component.scss'],
})
export class BoudElementFormComponent implements OnInit {
    @Input() controlName: string;
    @Input() actionType: string;
    @Input() group: FormGroup<any>;
    @Input() elements : string[] | UdeuBoud[];
    @Input() references : UdeuBoud[];
    @Input() disabled: boolean;
    
    actionTitle: string;
    
    private _formBuilder = inject(FormBuilder);
    
    formGroup: FormGroup<any>;
    
    options: UdeuBoud[] = [];
      
    constructor(protected store: Store<AppStore>, public dialog: MatDialog) { }
    
    ngOnInit(): void {
        this.formGroup = this.createForm();
        this.getTitle();
        const bouds: UdeuBoud[] = this.elements?.length > 0 ? this.elements as UdeuBoud[] : this.references;
        if (bouds) {
            bouds.forEach((boud: UdeuBoud) => {
                const form = this.createForm(boud);
                this.formArray.push(form);
            });
        }
    }

    get formArray(): FormArray  {
        return this.group.get(this.controlName) as FormArray;
    }

    formArrayGroup (index: number): FormGroup {
        return this.formArray.at(index) as FormGroup;
    }
    
    createForm(boud?: UdeuBoud, title? : string): FormGroup<any> {
        return this._formBuilder.group({
            search: ['', [Validators.minLength(3)]],
            id: [{ value: boud?.id, disabled: true }],
            name: [{ value: boud?.name, disabled: true }],
            title: [{ value: title ?? boud?.content?.spanishContent?.title, disabled: true }],
            [TYPE_FIELD]: [{ value: boud?.data?.type, disabled: true }],
            [SUBTYPE_FIELD]: [{ value: boud?.data?.subtype, disabled: true }],
            [PRIMARY_APPROVING_BODY_FIELD]: [{ value: boud?.data?.primaryApprovingBody, disabled: true }],
            [SECONDARY_APPROVING_BODY_FIELD]: [{ value: boud?.data?.secondaryApprovingBody, disabled: true }],
            [SECONDARY_APPROVING_BODY_SUB_FIELD]: [{ value: boud?.data?.secondaryApprovingBodySub, disabled: true }],
            [PROVISION_NUMBER_FIELD]: [{ value: boud?.data?.provisionNumber, disabled: true }],
            [ACTION_TYPE_FIELD]: [{ value: boud?.data?.actionType, disabled: true }],
            [APPROVAL_DATE_FIELD]: [{ value: boud?.data?.approvalDate, disabled: true }],
            [EFFECTIVE_DATE_FIELD]: [{ value: boud?.data?.effectiveDate, disabled: true }],
        });
    }
    
    add(boud: UdeuBoud,title?:string) {
        const form = this.createForm(boud, title);
        this.formArray.push(form);
        this.resetForm();
    }
    
    addSubelements(subelements?: UdeuBoud[]){
        if(subelements){
            subelements.forEach((boud: UdeuBoud) => {
                const form = this.createForm(boud);
                this.formArray.push(form);
            });
        }
    }

    resetForm() {
        this.options = [];

        this.formGroup.reset();
        this.formGroup.setErrors(null);
        this.formGroup.markAsUntouched();
    }
      
    delete(index: number) {
        const formArray = this.formArray;
        formArray.removeAt(index);
    }

    view(index: number) {
        const UUID = this.formArrayGroup(index).get('id').value;
        this.dialog.open(CreateBoudDialogComponent,
        {
            disableClose: true,
            autoFocus: true,
            width: '80%',
            maxHeight: '90%', 
            data:  { UUID, boudActionType: BoudActionTypes.ViewBoud }
        },
        );
    }

    getTitle() {
        switch (this.actionType) {
            case actionTypeEnum.UDEU_BOUD_CORRECTION_ACTION_TYPE:
            this.actionTitle = this.references?.length > 0 ? "Corregido por" : "Se corrigen";
            break;

            case actionTypeEnum.UDEU_BOUD_MODIFICATION_ACTION_TYPE:
            this.actionTitle = this.references?.length > 0 ? "Modificado por" : "Se modifican";
            break;

            case actionTypeEnum.UDEU_BOUD_SUSPENSION_ACTION_TYPE:
            this.actionTitle = this.references?.length > 0 ? "Suspendido por" :  "Se suspenden";
            break;

            case actionTypeEnum.UDEU_BOUD_REPEAL_ACTION_TYPE:
            this.actionTitle = this.references?.length > 0 ? "Derogado por" : "Se derogan";
            break;
        
            default:
            this.actionTitle = this.references?.length > 0 ? "Mencionado por" :  "Se mencionan";
            break;
        }
    }
}